import React from 'react'
import { Form, DatePicker } from '@surecompanies/core_components'
import {
  FieldsGrid,
  FieldGroup,
} from '../../PaymentDetailModal/PaymentDetailModal.styles'
import {
  StatusUpdateFormKey,
  StatusUpdateFormKeyLabels,
} from '../statusUpdate.type'

interface BenefitEndDateFieldsProps {
  fieldKey?:
    | StatusUpdateFormKey.UPDATE_BENEFIT_END_DATE
    | StatusUpdateFormKey.UPDATE_EFFECTIVE_DATE
}

export function BenefitEndDateFields({
  fieldKey = StatusUpdateFormKey.UPDATE_BENEFIT_END_DATE,
}: BenefitEndDateFieldsProps) {
  return (
    <div style={{ marginTop: '16px' }}>
      <FieldsGrid>
        <FieldGroup>
          <Form.Item
            name={fieldKey}
            label={StatusUpdateFormKeyLabels[fieldKey]}
            rules={[
              {
                required: true,
                message: `${StatusUpdateFormKeyLabels[fieldKey]} is required`,
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <DatePicker
              style={{ width: '100%' }}
              format="MM-DD-YYYY"
              placeholder="Select date"
            />
          </Form.Item>
        </FieldGroup>
      </FieldsGrid>
    </div>
  )
}
